import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import ReactTable from 'react-table';
import "react-table/react-table.css";
import { getDeparturesList, cancel } from '../services/departures';

const Departures = (props) => {
    const [loading, setLoading] = useState(false);
    const [departures, setDepartures] = useState([]);
    const [pages, setPages] = useState(1);
    const [show, setShow] = useState(10);
    const [columns, setColumns] = useState([]);
    const [screenDebt, setScreenDebt] = useState(0);
    const [screenBalance, setScreenBalance] = useState(0);
    const table = useRef();

    useEffect(() => { 
        function generateColumns() {
            let columns = [{
                Header: "Cliente",
                id: 'user.name',
                accessor: (d) => d.user.name,
            },
            {
                Header: "Embarcación",
                id: 'boat.name',
                accessor: (d) => d.boat.name,
            },
            {
                Header: 'Estado',
                accessor: 'status',
            },
            {
                Header: 'Sucursal',
                accessor: 'branch',
            },
            {
                id: 'date',
                Header: 'Fecha de Salida',
                accessor: (d) => new Date(d.date).toLocaleDateString('es-ar'),
                filterable: false,
            },
            {
                id: 'debt',
                Header: 'Deuda Salida',
                accessor: (d) => <span className={!d.debt || d.debt > 0 ? 'text-success' : 'text-danger' }>$ {d.debt || 0}</span>,
                filterable: false,
            },
            {
                id: 'user.balance',
                Header: 'Balance de Usuario',
                accessor: (d) => <span className={!d.user.balance || d.user.balance > 0 ? 'text-success' : 'text-danger' }>$ {d.user.balance || 0}</span>,
                filterable: false,
            },
            {
                Header: '',
                accessor: '_id',
                filterable: false,
                className: 'actions-cell',
                Cell: property => (
                       <NavLink to={"/departures/" + property.value } className="btn btn-xs btn-circle btn-default">
                            <i className="ico fas fa-info text-dark" />
                        </NavLink>
                ),
                width: 50
            }
            ];
        
            setColumns(columns);
        };
        generateColumns();

        return function cleanup() {
            cancel();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchData = async (state, instance) => {
        setLoading(true);
        
        let options = {
            sort: state.sorted.length > 0 ? state.sorted[0].id : 'date',
            direction: state.sorted.length > 0 ? state.sorted[0].desc ? 'desc' : 'asc' : 'desc',
            filters: state.filtered.length > 0 ? state.filtered : [],
            results: state.pageSize,
            offset: (state.page +1) * state.pageSize - state.pageSize
        };

        try {
            let data = await getDeparturesList(options);
            if (data.departures.length > -1) {
                setDepartures(data.departures);

                const a = data.departures.reduce((acc, current) => {
                    if (typeof acc === 'object') {
                        return ((acc.debt || 0) + (current.debt || 0))
                    } else {
                        return (acc + (current.debt || 0))
                    }
                });

                const b = data.departures.reduce((acc, current) => {
                    if (typeof acc === 'object') {
                        console.log('current debt 1', current.debt, acc.debt);
                        if (current.debt < 0) {
                            return ((acc.debt || 0) + (current.debt || 0));
                        } 
                        return ((acc.debt || 0));
                    } else {
                        console.log('current debt 2', current.debt, acc);
                        if (current.debt < 0) {
                            return (acc + (current.debt || 0));
                        }
                        return ((acc || 0));
                    }
                });

                setScreenBalance(a);
                setScreenDebt(b);

                setLoading(false);
                setPages(data.pages);
                setShow(data.results);
            } else {
                setScreenDebt(0);
                setScreenBalance(0);
                setLoading(false);
            }
        } catch (e) {
            setScreenDebt(0);
            setLoading(false);
        }
    };
    
    return (
        <section>
            <div className='row'>
                <div className='col-md-6 col-xs-12 align-self-center'>
                    <h3>Salidas</h3>
                </div>
            </div>
            <hr />
            <ReactTable
                ref={table}
                data={departures}
                columns={columns}
                pages={pages}
                defaultPageSize={show}
                loading={loading}
                showPagination={true}
                showPaginationTop={false}
                showPaginationBottom={true}
                showPageJump={true}
                resizable={true}
                sortable={true}
                filterable={true}
                manual
                onFetchData={fetchData}
                onSortedChange={cancel}
                onFilteredChange={cancel}
                className="-striped -highlight"
            />
            <p className="text-bold mt-3">Balance de Salidas Pantalla: ${screenBalance}</p>
            <p className="text-bold mt-3">Deuda de Salidas en Pantalla: ${screenDebt}</p>
        </section>
    );
};

const mapStateToProps = (state) => {
    return ({timeZone: state.auth.user.timezone, locale: state.auth.user.locale});
};

export default connect(mapStateToProps)(Departures);
